import { getLookupValuePageTabs } from './lookups';
import { OFFSET_PARAM_NAME, PRODUCTS_PER_PAGE_PARAM_NAME, ECustomerType, GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME } from './constants';
import { PageLoadEventParam } from './types/events';

export const updatePageLoadData = (params: PageLoadEventParam) => {
  const event = new CustomEvent(GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME, {
    detail: params,
    bubbles: true,
    composed: true,
  });

  window.dispatchEvent(event);
};

/**
 * Sets Query param if exists or removes from params if the value wasn't provided
 */
export const setQueryParam = (
  searchParams: URLSearchParams,
  paramName: string,
  value: string,
): void => {
  if (value) {
    searchParams.set(paramName, value);
  } else {
    searchParams.delete(paramName);
  }
};

export function setPaginationParams(
  offset?: number,
  nrpp?: number,
  pushToHistory = false,
): URLSearchParams {
  const searchParams = new URLSearchParams(window.location.search);
  setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
  setQueryParam(searchParams, PRODUCTS_PER_PAGE_PARAM_NAME, nrpp.toString());
  if (pushToHistory) {
    window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
  }
  return searchParams;
}

export const setArticleTitle = (articleTitle: string): void => {
  updatePageLoadData({ articleTitle: getLookupValuePageTabs(articleTitle) });
};

export const isAnalyticsEnabled = (): boolean => !window.analyticsDisabled;

/**
 * Returns cookie value or undefined if no cookie.
 */
export const getCookie = (name: string): string | undefined => {
  const regexp = new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`);
  const matches = document.cookie.match(regexp);

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const getUserSessionLoggedInValue = (): string | undefined => {
  return getCookie(ECustomerType.CLASSIFICATION1);
};
